import api from "../service";
import { store } from "store/configureStore";
import { hotToast, middlewareResponse } from "utils";

export const getViews = async (idView: number, idsReportType: string) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `Vista/GetVistas?idVista=${idView}&idsTipoReporte=${idsReportType}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const addView = async (form: FormData, isReport: boolean) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  let isView = "La vista";
  if (isReport) {
    isView = "El reporte";
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Vista/InsertVista`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast(`${isView} se dío de alta correctamente`, "SUCCESS");
    return true;
  }
  data?.message && hotToast(data?.message,"ERROR");
  return null;
};

export const updateView = async (
  id: number,
  form: FormData,
  isReport: boolean,
  disableOrEnable?: boolean
) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  let isView = "La vista";
  if (isReport) {
    isView = "El reporte";
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPut(
    `Vista/UpdateVista/${id}`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    let messageView = disableOrEnable
      ? `${isView} se ${
          form.get("idEstatus") === "1" ? " activo" : "desactivo"
        } correctamente`
      : `${isView} se guardó correctamente`;
    hotToast(messageView, "SUCCESS");
    return true;
  }
  data?.message && hotToast(data?.message,"ERROR");
  return null;
};

export const getByPerfil = async (id: number | null) => {
  await api.setToken();

  let response = await api
    .requestGet(`Vista/byPerfil/${id ? id : ""}`)
    .then(middlewareResponse);

  return response;
};

export const getFindUsuarioVista = async (id: number | null) => {
  await api.setToken();

  let response = await api
    .requestGet(`Vista/byUsuario/${id ? id : ""}`)
    .then(middlewareResponse);

  return response;
};
